module.exports = __webpack_public_path__ + "media/app/assets/specializations/shaman/enhancement-61fbca8511efdcf3e3a1b6313822a839.png";